'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var GetIntrinsic = require('get-intrinsic');

var $String = GetIntrinsic('%String%');

var ToPrimitive = require('./ToPrimitive');

var ToString = require('./ToString'); // https://ecma-international.org/ecma-262/6.0/#sec-topropertykey


module.exports = function ToPropertyKey(argument) {
  var key = ToPrimitive(argument, $String);
  return _typeof(key) === 'symbol' ? key : ToString(key);
};